import { render } from "./onboarding-ad.vue?vue&type=template&id=171e6b31&lang=pug"
import script from "./onboarding-ad.vue?vue&type=script&lang=js"
export * from "./onboarding-ad.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__